import InstanceApi from "@/services/apiClient.js";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      accountExist: false,
    };
  },

  computed: {
    ...mapGetters({ isUserLoggedIn: "isCurrentUserIsLoggedIn" }),
    ...mapGetters({ storeUrlPrefix: "getStoreUrlPrefix" }),
  },

  methods: {
    async verifyAccountByEmail(email) {

      if (this.isUserLoggedIn) {
        return;
      }

      try {
        const verifyAccountUrl = "mcp/checkout/canCreateCustomer/email/" + email;
        const response = await InstanceApi.get(verifyAccountUrl);
        this.accountExist = !response.data ? true : false;
        return this.accountExist;
      } catch (error) {
        console.log(error)
      }
    },
  },
};
